import { Box, Divider, Grid, Typography } from '@mui/material'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import DetailHeroPanel from '../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import CardHero from '../../../../shared/components/frontoffice/CardHero'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import { MoreInfoDetail } from '../../../library/models/resource'
import { useNewsDetailsPanel } from '../hooks/useNewsDetailsPanel'

interface NewsDetailsPanelProps {
  newsSelected: any
  news: any[]
  isAdmin: boolean
  isMobile: boolean
  infoDetail: MoreInfoDetail
}

const NewsDetailsPanel = ({ newsSelected, news, isAdmin, isMobile, infoDetail }: NewsDetailsPanelProps) => {
  const { t } = useTranslation(['global'])
  const { sortNews, authUser, handleShowNews, handleEdit, cutContent, handleFavoriteNewsClick } = useNewsDetailsPanel(news)

  return (
    <Grid item xs={12} md={isAdmin ? 4 : 3}>
      {isAdmin ? (
        <>
          <DetailHeroPanel
            visibility={newsSelected.visibility !== null && newsSelected.visibility}
            brand={newsSelected?.brand?.name}
            title={newsSelected.title !== null && newsSelected.title}
            author={newsSelected.responsibles?.length > 0 ? newsSelected.responsibles[0].name : null}
            statusC={
              <>
                {newsSelected.status === 0 && `${t('active')}`}
                {newsSelected.status === 1 && `${t('inactive')}`}
                {newsSelected.status === 2 && `${t('draft')}`}
              </>
            }
            description={newsSelected.description !== null && newsSelected.description}
            edit={handleEdit}
            share={
              <ShareIcon
                meta={true}
                visibility={newsSelected.visibility}
                title={newsSelected.title}
                description={newsSelected.description || ''}
                link={window.location.href}
                multimedia={newsSelected.image_url}
                component="buttonTextGreen"
                type="course"
                buttonTextGreen={t('share')}
              />
            }
          />
          {!isMobile && <DetailInfoPanel attributes={infoDetail} />}
        </>
      ) : (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', pb: 3, mt: 3 }}>
            <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
              {t('more-news')}
            </Typography>
            <Divider sx={{ marginLeft: 2, flexShrink: 1 }} />
          </Box>

          {sortNews.slice(0, 5).map((currentNews: any) => (
            <Box key={currentNews.id} sx={{ mb: 2 }}>
              <CardHero
                onClickCard={() => handleShowNews(currentNews.slug)}
                type={1}
                redirect={`/noticias/${currentNews.slug}`}
                cardBrandName={currentNews.brand?.name || ''}
                cardVisibility={currentNews.visibility}
                cardImage={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                cardTitle={currentNews.title}
                cardDescription={<div dangerouslySetInnerHTML={{ __html: cutContent(currentNews.content) }} />}
                cardDate={`${dayjs(currentNews.created_at).fromNow()}`}
                cardActions={
                  <ShareIcon
                    meta={true}
                    visibility={currentNews.visibility}
                    title={currentNews.title}
                    description={currentNews.title}
                    link={`${window.location.origin}/noticias/${currentNews.slug}${window.location.search}`}
                    type="news"
                    multimedia={`${import.meta.env.VITE_AWS_URL}/novelties/${currentNews.image_url}`}
                  />
                }
                favoriteState={Boolean(currentNews.favoriteId)}
                onClickFavorite={authUser === null ? undefined : handleFavoriteNewsClick(currentNews.id)}
              />
            </Box>
          ))}
        </>
      )}
    </Grid>
  )
}

export default NewsDetailsPanel
